var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"dragdrop-wrapper",class:{ __onDrag: _vm.isDrag }},[_vm._t("default",null,{"isDrag":_vm.isDrag,"isDragOverWrapper":_vm.isDragOverWrapper})],2)}
var staticRenderFns = []

export { render, staticRenderFns }